<template>
  <div class="heighthv ba_f">
    <el-menu :default-active="activeIndex" :router="true" class="el-menu-demo" mode="horizontal" @select="handleSelect">
      <el-menu-item index="revokeorder">{{ $t('order.settings.revokeOrder') }}</el-menu-item>
      <el-menu-item index="orderCancelSet">{{ $t('order.settings.cancelList') }}</el-menu-item>
    </el-menu>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeIndex: 'revokeorder'
    };
  },
  created() {
    this.activeIndex = this.$route.path.replace(/\//g, '');
  },
  methods: {
    handleSelect(msg) {
      this.activeIndex = msg;
    }
  }
};
</script>

<style lang="stylus" scoped></style>
